import { getUa } from './uaService'

export { getUa }
